import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common-service/common.service';
import { ChartType, GoogleChartsModule}from 'angular-google-charts';

@Component({
  selector: 'controls-bo-stackedbarchart',
  templateUrl: './bo-stackedbarchart.component.html',
  styleUrls: ['./bo-stackedbarchart.component.scss'],
  imports:[GoogleChartsModule]
})
export class BoStackedbarchartComponent implements OnInit {
  @Input() chartForm!: FormGroup;
  chartType = ChartType.ColumnChart;
  title = '';
  myData = [];
  columnNames = [];
  options = {
    hAxis: { title: '', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    vAxis: { minValue: 0, textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    isStacked: true,
    // legend: { position: 'bottom' },
    bar: { groupWidth: '50%' },
    // bar: {groupWidth: "11%"},
    legend: { position: "none", MaxLines: 0, textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    //colors: ['#0177ff', '#79b5fd', '#ff953b', '#ff3b5b'],
    colors: ['#6852c8', '#69d141', '#ff953b', '#ff3b5b'],
    //colors:[],
    // chartArea: {
    //   bottom: 50,
    //   left: 20,
    //   right: 0,
    //   top: 20
    // }
    chartArea: {
      bottom: 50,
      left: 50,
      right: 20,
      top: 20
    }
  };
  cStyle: any = {};
  colors: any = [];

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    if (this.chartForm.value.data) {
      this.myData = this.chartForm.value.data;
      this.columnNames = this.chartForm.value.columnNames;
      this.cStyle = {
        width: this.chartForm.value.width,
        height: this.chartForm.value.height
      };
      this.colors = this.chartForm.value.colors;
      this.commonService.ogLog('this.colors', this.colors)
      if (this.colors)
        this.options.colors = this.colors;
      if (this.chartForm.value['legendPosition'])
        this.options['legend'].position = this.chartForm.value['legendPosition'];
      if (this.chartForm.value['bargroupwidth'])
        this.options['bar'].groupWidth = this.chartForm.value['bargroupwidth'];
      if (this.chartForm.value['legendMaxLine'])
        this.options['legend'].MaxLines = this.chartForm.value['legendMaxLine'];
      let bar = this.chartForm.value.bar;
      if (bar == 'horizontal')
        this.chartType = ChartType.BarChart;


    }
  }

}
